import { routes } from 'app/routing/routesConfig';
import { Navigate, useLocation } from 'react-router-dom';
import React from 'react';

export const IndexNavigate = () => {
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: routes.auth.path,
        search: location.search,
      }}
      replace
      state={location.state}
    />
  );
};
